import { ProductViewBase } from '@amzn/coral_com-amazon-sssapinterface-model-structures-credits';
import { useBundle } from '@amzn/react-arb-tools';
import { IconType } from '@amzn/sss-website-theme';

import { COMMON_BUNDLE_NAME } from 'src/constants';
import { t } from 'src/helpers';

/**
 * Constants containing mappings from common EAC taxonomy attributes to their human-friendly Tag attributes.
 */

export type StringWithIconConfig = Record<string, { stringId: string; icon: IconType }>;

export const CREDIT_CATEGORY_TAG_CONFIG: StringWithIconConfig = {
  NATURE_BASED: {
    stringId: 'creditCategoryTag_natureBased',
    icon: 'leaf',
  },
  TECH_BASED: {
    stringId: 'creditCategoryTag_techBased',
    icon: 'leaf',
  },
};

export const CREDIT_TYPE_TAG_CONFIG: StringWithIconConfig = {
  AVOIDANCE: {
    stringId: 'creditTypeTag_avoidance',
    icon: 'barChart',
  },
  REMOVAL: {
    stringId: 'creditTypeTag_removal',
    icon: 'barChart',
  },
  REDUCTION: {
    stringId: 'creditTypeTag_reduction',
    icon: 'barChart',
  },
};

export const CREDIT_SEGMENT_TAG_CONFIG: StringWithIconConfig = {
  REDUCING_DEFORESTATION: {
    stringId: 'creditSegmentTag_reducingDeforestation',
    icon: 'community',
  },
  NATURE_BASED_CARBON_DIOXIDE_REMOVAL: {
    stringId: 'creditSegmentTag_natureBasedCarbonDioxideRemoval',
    icon: 'community',
  },
  TECHNOLOGICAL_CARBON_DIOXIDE_REMOVAL: {
    stringId: 'creditSegmentTag_technologicalCarbonDioxideRemoval',
    icon: 'community',
  },
  SUPERPOLLUTANT_ABATEMENT: {
    stringId: 'creditSegmentTag_superpollutant',
    icon: 'superpollutant',
  },
  LOW_CARBON_FUELS: {
    stringId: 'creditSegmentTag_lowerCarbonFuels',
    icon: 'community',
  },
  CONSTRUCTION_MATERIALS: {
    stringId: 'creditSegmentTag_constructionMaterials',
    icon: 'community',
  },
  AGRICULTURE: {
    stringId: 'creditSegmentTag_agriculture',
    icon: 'community',
  },
  // Deprecated Tags
  HALTING_DEFORESTATION: {
    stringId: 'creditSegmentTag_haltingDeforestation',
    icon: 'community',
  },
  TECHNOLOGICAL_REMOVAL: {
    stringId: 'creditSegmentTag_technologicalRemoval',
    icon: 'community',
  },
  RESTORATION: {
    stringId: 'creditSegmentTag_restoration',
    icon: 'community',
  },
};

export const useProductTags = (productData: ProductViewBase | null | undefined) => {
  const [commonBundle] = useBundle(COMMON_BUNDLE_NAME);

  if (!productData) return [];

  const tagMappings = [
    { value: productData.productCreditCategory, config: CREDIT_CATEGORY_TAG_CONFIG },
    { value: productData.productCreditType, config: CREDIT_TYPE_TAG_CONFIG },
    { value: productData.productCreditSegment, config: CREDIT_SEGMENT_TAG_CONFIG },
  ];

  return tagMappings
    .filter(({ value, config }) => value && config[value])
    .map(({ value, config }) => ({
      icon: config[value!].icon,
      copy: t(commonBundle, config[value!].stringId),
    }));
};
